<template>
  <div>
    <div class="pw-navbar" v-if="organization">
      <div class="pw-navbar__expander" v-if="!minimalNavbar" @click="$root.$emit('collapse', true)">
        <i class="mdi mdi-menu"></i>
      </div>
      <div class="pw-navbar__logo">
        <router-link :to="{ name: 'home' }">
          <img src="../assets/pw-logo.svg" />
        </router-link>
      </div>
      <div class="pw-navbar__info">
        <template v-if="!minimalNavbar">
          <span>{{ apps[nameApp] }}</span>
          <span class="divider-info"></span>

          <span>{{ organization.organizationDescription }}</span>
        </template>
      </div>
      <div class="pw-navbar__account">
        <Dropdown
          position="bottom-right"
          :closeOnClick="closeMenu"
        >
          <div slot="trigger" class="account_data">
            <slot name="account-profile" v-bind:user="user">
              <div class="account__photo">
                {{ user.profile.UserName | firstLetter }}
              </div>
              <div class="account__name">
                {{ user.profile.UserName }}
                &nbsp;
                <i class="mdi mdi-chevron-down"></i>
              </div>
            </slot>
          </div>

          <DropdownItem :clickable="false">
            <UserInformation :closeMenu="closeMenu" :organization="organization" />
          </DropdownItem>
        </Dropdown>
      </div>
      <div v-if="!minimalNavbar" class="pw-navbar__notifications">
        <span
          class="notification__count"
          :class="{
            'notification__count--has-notification': numberOfNotifications > 0,
          }"
          @click="showNotifications = true"
        >
          <i class="mdi mdi-bell-outline"></i>
        </span>
      </div>
      <Drawer
        v-model="showNotifications"
        title="Notificaciones"
        class="custom-drawer-notifications"
      >
        <NotificationsList
          v-if="hasNotifications"
          @countNotifications="(count) => (numberOfNotifications = count)"
          :showNotifications="showNotifications"
          :organization="organization"
        />
      </Drawer>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UserInformation from './UserInformation.vue';
import NotificationsList from './NotificationsList.vue';
import Drawer from './Drawer.vue';

export default {
  name: 'Navbar',
  props: {
    minimalNavbar: {
      type: Boolean,
      default: false,
    },
    organization: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    UserInformation,
    NotificationsList,
    Drawer,
  },
  mounted() {
    this.$root.$on('showPanelNotifications', () => {
      this.showNotifications = true;
    });
  },
  data() {
    return {
      apps: {
        STM: 'Timbrado',
        CAAH: 'Caja de ahorro',
        WA: 'Work apps',
      },
      nameApp: process.env.VUE_APP_PROJECT,
      showNotifications: false,
      numberOfNotifications: 0,
      closeMenu: true,
      organizationsAllowed: [],
    };
  },
  filters: {
    firstLetter(val) {
      try {
        return val.slice(0, 1);
      } catch (error) {
        return 'A';
      }
    },
  },
  computed: {
    ...mapState('User', ['user']),
    hasNotifications() {
      return process.env.VUE_APP_GRAPHQL_ENDPOINT;
    },
  },
};
</script>

<style lang="scss">
.custom-drawer-notifications {
  .pw-drawer-wrapper-body {
    width: 400px;
  }
}
.notification__count {
  margin-left: 8px;
  color: #fff;
  cursor: pointer;
  position: relative;
  font-size: 22px;
  &.notification__count--has-notification {
    &::after {
      display: block;
    }
  }
  &::after {
    width: 10px;
    height: 10px;
    display: none;
    content: '';
    border-radius: 3px;
    position: absolute;
    background-color: #f25555;
    top: 6px;
    right: 0;
  }
}

@media all and (max-width: 768px) {
  .pw-navbar {
    margin-left: 0 !important;
    width: 100% !important;
  }
  .account__name {
    display: none;
  }
}
.log-out {
  cursor: pointer;
}
.notify-section {
  color: white;
  margin-left: 10px;
  position: relative;
  cursor: pointer;
  i {
    font-size: 24px;
  }
  .notification-count {
    background-color: #f25555;
    color: #333;
    font-size: 10px;
    line-height: 8px;
    position: absolute;
    top: 6px;
    right: 0;
    border-radius: 50%;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.pw-navbar {
  transition: all 0.3s ease-in-out;
  height: 55px;

  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  background: #3d65c0;
  padding: 0 12px;
  display: flex;
  align-items: center;
  &__logo {
    margin-right: 24px;
    display: flex;
    align-items: center;
    a {
      display: flex;
      height: 20px;
      img {
        height: 20px;
      }
    }
  }
  &__lang {
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .switcher {
      margin-left: 8px;
      margin-right: 8px;
    }
  }
}
.pw-navbar__expander {
  cursor: pointer;
  margin-right: 24px;
  color: #fff;
  font-size: 32px;
  padding-top: 1px;
}
.pw-navbar__info {
  flex: auto;
  font-size: 12px;
  color: #fff;
  display: flex;
  align-items: center;
}

.divider-info {
  width: 1px;
  height: 16px;
  background-color: #fff;
  display: inline-block;
  margin-right: 16px;
  margin-left: 16px;
}
.account__name {
  font-size: 12px;
  color: white;
}

.pw-navbar__app {
  color: white;
  font-size: 24px;
  cursor: pointer;
}

.account__photo {
  width: 32px;
  height: 32px;
  background-color: #f5f5f5;
  border-radius: 50%;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  text-transform: uppercase;
  color: #294380;
}
.account_data {
  display: flex;
  align-items: center;
}
</style>
